import {useEffect, useState} from 'react'
import {Button, Col, Container, Form, OverlayTrigger, Row, Stack, Tooltip} from 'react-bootstrap'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import {useLocation, useNavigate, useParams, useSearchParams} from 'react-router-dom'
import {KTCard, KTIcon} from '../../../../../_metronic/helpers'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {get_Tables, get_Tables_company} from '../../../../services/campos'
import {
  createCompleteSheet,
  getCompleteSheet,
  updateCompleteSheet,
} from '../../../../services/fichas'
import {fetchMenuActionsByRole, fetchSubMenuByUrl} from '../../../../services/menu'
import {tipos} from '../../../../services/tipos'
import {showMessage, showMessageConfirmacion} from '../../../../shared/Alerts'
import {useAuth2} from '../../../authv2/Auth2Provider'
import {GoBackButton} from '../../../generales_component/GoBackButton'
import {AssignmentEditModal} from '../assignment-edit-modal/AssignmentEditModal'
import {AssignmentRequeridoModal} from '../assignment-requerido-modal/AssignmentRequeridoModal'
import {FieldEditModal} from '../field-edit-modal/FieldEditModal'
import {AssignmentEntityModal} from '../partner-entity-modal/AssignmentEntityModal'
import {PreviewModal} from '../preview-modal/PreviewModal'
import {SectionEditModal} from '../section-edit-modal/SectionEditModal'
import {Field, FieldDocument, Section, Sheet, Type} from '../Sheet'
import {SheetEditContext, Table_Item} from '../SheetContexts'
import {DraggableSectionList} from './DraggableSectionList'
import { DocumentEditModal } from '../document-edit-modal/DocumentEditModal'
import { useUserInfo } from '../../../../routing/store/InfoUserProvider'

type PreviewModeType = 'Colaborador' | 'Administrador'
const fichasBreadcrumbs = [
  {
    title: 'Configuración',
    path: '/configuracion/fichas',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const SheetEdit = () => {
  const navigate = useNavigate()
  const {id, shouldExecuteModal} = useParams()
  const [searchParams] = useSearchParams()
  const previewModeParam = searchParams.get('previewModeParam') as PreviewModeType

  useEffect(() => {
    if (id) {
      setTitle('Editar Ficha')
      handleGetSheet(id)
      if (shouldExecuteModal == 'true') {
        openPreviewModal(previewModeParam ?? 'Administrador')
      }
    }
  }, [])

  const goBack = () => {
    navigate('/configuracion/fichas')
  }

  const {procesosGrouped, unidadesAdmin} = useUserInfo()
  const [isSectionModalOpen, setSectioModalStatus] = useState(false)
  const [isFieldModalOpen, setFieldModalStatus] = useState(false)
  const [isDocumentModalOpen, setDocumentModalStatus] = useState(false)
  const [isAssignmentModalOpen, setAssignmentModalStatus] = useState(false)
  const [isAssignmentRequeridoModalOpen, setAssignmentRequeridoModalStatus] = useState(false)
  const [isPreviewModalOpen, setPreviewModalStatus] = useState(false)
  const [loading, setLoading] = useState(false)
  const [formLoading, setFormLoading] = useState(false)
  const [title, setTitle] = useState('Nueva Ficha')
  const [validated, setValidated] = useState(false)
  const {selectedRole} = useAuth2()
  const [permissions, setPermissions] = useState<string[]>([])
  const location = useLocation()
  const currentPath = '/configuracion/fichas'
  const [formDataFirmas, setFormDataFirmas] = useState({
    idproceso: '',
    unidad: '',
  })
  const [sheetData, setSheetData] = useState<Sheet>({
    name: '',
    type: 'write',
    description: '',
    sections: [],
  })
  const [tables, setTables] = useState<Table_Item[]>([])
  const [types, setTypes] = useState<Type[]>([])
  const [sectionData, setSection] = useState<Section>({
    id: '',
    name: '',
    description: '',
    dynamic: false,
    fields: [],
    filter: false,
  })

  const [fieldData, setField] = useState<Field>({
    id: '',
    name: '',
    tag: '',
    isDependent: false,
    responseType: '',
    comment: '',
    visible: true,
    editable: false,
    required: false,
    actualizable: false,
    collectionName: '',
    options: [],
    tablaData: [],
    assignedTo: '',
    dependentField: '',
    dependentFieldResponse: '',
    variable: false,
  })
  const [isEntityModalOpen, setIsEntityModalOpen] = useState(false)

  const openEntityModal = () => {
    setIsEntityModalOpen(true)
  }

  const closeEntityModal = () => {
    setIsEntityModalOpen(false)
  }

  const [fieldDocumentData, setFieldDocument] = useState<FieldDocument>({
    id: '',
    tipo: '',
    titulo: '',
    obligatorio: false
  })

  useEffect(() => {
    const fetchPermissions = async () => {
      const response = await fetchMenuActionsByRole(selectedRole)
      if (response.success) {
        const subMenuResponse = await fetchSubMenuByUrl(currentPath)
        if (subMenuResponse.success) {
          const subMenuId = subMenuResponse.data.id_hijo
          const permissionsForSubMenu =
            response.data.find((item: any) => item.subMenuId === subMenuId)?.acciones || []
          setPermissions(permissionsForSubMenu)
        }
      }
    }

    fetchPermissions()
  }, [selectedRole, currentPath])

  const openSectionModal = () => {
    setSectioModalStatus(true)
  }

  const clearSection = () => {
    setSection({
      id: '',
      name: '',
      description: '',
      dynamic: false,
      filter: false,
    })
  }

  const clearField = () => {
    setField({
      id: '',
      name: '',
      tag: '',
      isDependent: false,
      responseType: '',
      comment: '',
      visible: true,
      editable: false,
      required: false,
      actualizable: false,
      collectionName: '',
      options: [],
      tablaData: [],
      assignedTo: '',
      dependentField: '',
      dependentFieldResponse: '',
      variable: false,
    })
  }

  const clearDocument = () => {
    setField({
      id: '',
      name: '',
      tag: '',
      isDependent: false,
      responseType: '',
      comment: '',
      visible: true,
      editable: false,
      required: false,
      actualizable: false,
      collectionName: '',
      options: [],
      tablaData: [],
      assignedTo: '',
      dependentField: '',
      dependentFieldResponse: '',
      variable: false,
    })
  }

  const closeSectionModal = () => {
    setSectioModalStatus(false)
    clearSection()
  }

  const openFieldModal = () => {
    setFieldModalStatus(true)
  }

  const closeFieldModal = () => {
    setFieldModalStatus(false)
    clearSection()
    clearField()
  }

  const openDocumentModal = () => {
    setDocumentModalStatus(true)
  }

  const closeDocumentModal = () => {
    setDocumentModalStatus(false)
    clearSection()
    clearDocument()
  }

  const openAssignmentModal = () => {
    setAssignmentModalStatus(true)
  }

  const closeAssignmentModal = () => {
    setAssignmentModalStatus(false)
    clearSection()
    clearField()
  }

  const openAssignmentRequeridoModal = () => {
    setAssignmentRequeridoModalStatus(true)
  }

  const closeAssignmentRequeridoModal = () => {
    setAssignmentRequeridoModalStatus(false)
    clearSection()
    clearField()
  }

  const [previewMode, setPreviewMode] = useState<PreviewModeType>(previewModeParam ?? 'Colaborador')

  const openPreviewModal = (mode: PreviewModeType) => {
    setPreviewMode(mode)
    setPreviewModalStatus(true)
  }

  const closePreviewModal = () => {
    setPreviewModalStatus(false)
  }

  const setData = (data: Sheet) => {
    setSheetData(data)
  }

  const setSectionData = (data: Section) => {
    setSection(data)
  }

  const setFieldData = (data: Field) => {
    setField(data)
  }
  
  const setFieldDocumentData = (data: FieldDocument) => {
    setFieldDocument(data)
  }

  const valueContextProvider = {
    isEntityModalOpen,
    closeEntityModal,
    openEntityModal,
    isSectionModalOpen,
    openSectionModal,
    closeSectionModal,
    isFieldModalOpen,
    openFieldModal,
    closeFieldModal,
    isDocumentModalOpen,
    openDocumentModal,
    closeDocumentModal,
    isAssignmentModalOpen,
    openAssignmentModal,
    closeAssignmentModal,
    isAssignmentRequeridoModalOpen,
    openAssignmentRequeridoModal,
    closeAssignmentRequeridoModal,
    sheetData,
    setData,
    sectionData,
    setSectionData,
    fieldData,
    setFieldData,
    fieldDocumentData, 
    setFieldDocumentData,
    isPreviewModalOpen,
    openPreviewModal,
    closePreviewModal,
    previewMode,
    setPreviewMode,
    setTables,
    tables,
    types,
    setTypes,
    formDataFirmas, 
    setFormDataFirmas
  }

  const handleChange = (e: any) => {
    setSheetData({...sheetData, [e.target.name]: e.target.value})
  }

  const validateForm = (e: any) => {
    const form = e.currentTarget
    if (form.checkValidity() === false) {
      e.preventDefault()
      e.stopPropagation()
    } else {
      handleSubmit(e)
    }

    setValidated(true)
  }

  const handleSubmit = (e: any) => {
    e.preventDefault()
    setLoading(true)

    if (id) {
      handleUpdateSheet(id, sheetData)
    } else {
      createCompleteSheet(sheetData)
        .then((response) => {
          if (response.success) {
            showMessageConfirmacion('success', '¿Deseas seguir modificando la Ficha?', ' ').then(
              (result) => {
                if (result.isConfirmed) {
                  navigate(`${currentPath}/edit/${response.ficha._id}/false`)
                } else {
                  goBack()
                }
              }
            )
          } else {
            console.log(response)
            showMessage('error', 'Hubo un error', response.error)
          }
          setLoading(false)
        })
        .catch((error) => {
          console.log(error)
          showMessage('error', 'Hubo un error', error.message)
          setLoading(false)
        })
    }
  }

  const handleGetSheet = (id: string) => {
    setFormLoading(true)

    getCompleteSheet(id)
      .then((response) => {
        setSheetData(response.data)
        setFormLoading(false)
      })
      .catch((error) => console.log(error))
  }

  const handleUpdateSheet = (id: string, data: Sheet) => {
    updateCompleteSheet(id, data)
      .then((response) => {
        if (response.success) {
          showMessageConfirmacion('success', '¿Deseas seguir modificando la Ficha?', ' ').then(
            (result) => {
              if (result.isConfirmed) {
                window.location.reload()
              } else {
                goBack()
              }
            }
          )
        } else {
          console.log(response)
          showMessage('error', 'Hubo un error', response.error)
        }

        setLoading(false)
      })
      .catch((error) => {
        console.log(error)
        showMessage('error', 'Hubo un error', error.message)
        setLoading(false)
      })
  }

  const getTables = () => {
    get_Tables_company()
      .then((response) => {
        setTables(response.data)
      })
      .catch((error) => console.log(error))
  }

  const getTypes = () => {
    tipos()
      .then((response) => {
        setTypes(response.data)
      })
      .catch((error) => console.log(error))
  }

  useEffect(() => {
    getTables()
    getTypes()
  }, [])

  const procesosByUnidad = (procesosGrouped[formDataFirmas.unidad] ?? []).concat(
    procesosGrouped.transversales
  )

  const handleInputChange = (event: any) => {
    const {name, value} = event.target
    setFormDataFirmas((prevFormData) => {
      return {...prevFormData, [name]: value}
    })

    /* if (formData.name !== '') {
      setHasErrorName(false)
    } */

    if (name === 'unidad') {
      /* setUnidad(value)
      setIdProcess('')
      setFormData((prevFormData) => {
        return {...prevFormData, idproceso: ''}
      }) */
    }
    if (name === 'idproceso') {
      // setIdProcess(value)
    }
  }

  return (
    <SheetEditContext.Provider value={valueContextProvider}>
      <PageTitle breadcrumbs={fichasBreadcrumbs}>{title}</PageTitle>
      <GoBackButton goBack={goBack} />
      <KTCard>
        {/* <div className='card-header border-0 pt-6'>
          <div className='card-toolbar'>
            <button type='button' className='btn btn-primary' onClick={() => goBack()}>
              <KTIcon iconName='arrow-left' className='fs-2' />
              Regresar
            </button>
          </div>
        </div> */}
        {formLoading ? (
          <div className='pt-12 pb-6'>
            <Container>
              <Row className='mb-3'>
                <Col sm>
                  <Stack gap={2}>
                    <Skeleton height={20} width={52} duration={1} style={{borderRadius: '5px'}} />
                    <Skeleton height={44} duration={1} style={{borderRadius: '10px'}} />
                  </Stack>
                </Col>
                <Col sm>
                  <Stack gap={2}>
                    <Skeleton height={20} width={52} duration={1} style={{borderRadius: '5px'}} />
                    <Skeleton height={44} duration={1} style={{borderRadius: '10px'}} />
                  </Stack>
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col sm>
                  <div className='d-flex justify-content-between'>
                    <div className='d-flex align-items-end'>
                      <Skeleton
                        height={20}
                        width={139}
                        duration={1}
                        style={{borderRadius: '5px'}}
                      />
                    </div>
                    <div className='d-flex'>
                      <Skeleton
                        height={44}
                        width={152}
                        duration={1}
                        style={{borderRadius: '10px', marginRight: '7px'}}
                      />
                      <Skeleton
                        height={44}
                        width={120}
                        duration={1}
                        style={{borderRadius: '10px'}}
                      />
                    </div>
                  </div>
                </Col>
              </Row>

              <Row className='mb-6'>
                <Col sm>
                  <Skeleton height={195} duration={1} style={{borderRadius: '10px'}} />
                </Col>
              </Row>

              <Row>
                <div className='d-flex justify-content-end'>
                  <Skeleton
                    height={44}
                    width={102}
                    duration={1}
                    className='mx-3'
                    style={{borderRadius: '10px'}}
                  />
                  <Skeleton height={44} width={96} duration={1} style={{borderRadius: '10px'}} />
                </div>
              </Row>
            </Container>
          </div>
        ) : (
          <Form className='pt-12 pb-6' validated={validated} onSubmit={validateForm} noValidate>
            <Container>
              <Row className='mb-3'>
                <Col sm>
                  <Form.Group controlId='formNombre'>
                    <Form.Label>Nombre</Form.Label>
                    <Form.Control
                      type='text'
                      required
                      placeholder='Ingrese un nombre'
                      name='name'
                      value={sheetData.name}
                      onChange={handleChange}
                      className='same-height'
                    />
                    <Form.Control.Feedback type='invalid'>
                      Escriba un nombre para la ficha.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col sm>
                  <Form.Group controlId='formDescripcion'>
                    <Form.Label>Descripción</Form.Label>
                    <Form.Control
                      type='text'
                      placeholder='Ingrese una descripción'
                      name='description'
                      value={sheetData.description}
                      onChange={handleChange}
                      className='same-height'
                    />
                  </Form.Group>
                </Col>

                <Col sm>
                  <Form.Group controlId='formDescripcion'>
                    <Form.Label>Tipo de ficha</Form.Label>
                    <Form.Control
                      as='select'
                      name='type'
                      className='same-height'
                      value={sheetData.type}
                      onChange={handleChange}
                      disabled={!!id}
                    >
                      <option value=''>Seleccionar</option>
                      <option value='write'>Escritura</option>
                      <option value='document'>Documento</option>
                      <option value='firma'>Firma</option>
                    </Form.Control>
                  </Form.Group>
                </Col>

                {/* <Col sm>
                <Form.Group controlId='formTipo'>
                  <Form.Label>Tipo</Form.Label>
                  <Form.Control
                    as='select'
                    value={sheetData.type}
                    name='type'
                    onChange={handleChange}
                  >
                    <option value='write'>Escritura</option>
                    <option value='upload'>Carga</option>
                  </Form.Control>
                </Form.Group>
              </Col> */}
              </Row>

              {/* <Row className='mb-3'>
                { sheetData.type == "firma" && (
                  <>
                    <Col sm>
                      <Form.Group controlId='formNombre'>
                        <Form.Label style={{paddingBottom: '3px'}}>Unidad</Form.Label>
                          <select
                            className={'form-select form-select-solid'}
                            aria-label='Select example'
                            value={formDataFirmas.unidad}
                            name='unidad'
                            onChange={(event) => handleInputChange(event)}
                          >
                            <option value=''>Seleccionar</option>
                            {unidadesAdmin.map((unidad) => (
                              <option key={unidad.id} value={unidad.id}>
                                {unidad.name}
                              </option>
                            ))}
                          </select>
                      </Form.Group>
                    </Col>
                    <Col sm>
                      <Form.Group controlId='formNombre'>
                        <Form.Label style={{paddingBottom: '3px'}}>Proceso</Form.Label>
                        <select
                          className={'form-select form-select-solid}'}
                          aria-label='Select example'
                          value={formDataFirmas.idproceso}
                          name='idproceso'
                          onChange={(event) => handleInputChange(event)}// Mostrar mensaje si hay usuarios seleccionados
                        >
                          <option value=''>Seleccionar</option>
                          {procesosByUnidad.map((x) => (
                            <option value={x.id} key={x.id}>
                              {' '}
                              {x.name}
                            </option>
                          ))}
                        </select>
                      </Form.Group>
                    </Col>
                    <Col sm></Col>
                  </>
                )}
              </Row> */}

              {/*<Row className='mb-3'>
              <Col sm>
                <Form.Group controlId='formDescripcion'>
                  <Form.Label>Descripción</Form.Label>
                  <Form.Control
                    type='text'
                    placeholder='Ingrese una descripción'
                    name='description'
                    value={sheetData.description}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col sm></Col>
            </Row> */}

              <Row className='mb-3'>
                <Col sm>
                  <div className='d-flex justify-content-between'>
                    <div className='d-flex align-items-end'>
                      <Form.Label>Listado de Secciones</Form.Label>
                    </div>
                    <div>
                      { sheetData.type !== "firma" && (
                        <>
                          <Button
                            variant='primary'
                            className='me-2'
                            onClick={() => {
                              if (id) {
                                window.open(
                                  `/configuracion/fichas/edit/${id}/${true}?previewModeParam=Colaborador`,
                                  '_blank'
                                )
                              } else {
                                openPreviewModal('Colaborador')
                              } 
                            }}
                          >
                            <KTIcon iconName='eye' className='fs-2' />
                            Vista Colaborador
                          </Button>

                          <Button
                            variant='primary'
                            className='me-2'
                            onClick={() => {
                              if (id) {
                                window.open(
                                  `/configuracion/fichas/edit/${id}/${true}?previewModeParam=Administrador`,
                                  '_blank'
                                )
                              } else {
                                openPreviewModal('Administrador')
                              }
                            }}
                          >
                            <KTIcon iconName='eye' className='fs-2' />
                            Vista Administrador
                          </Button>
                        </>
                      )}

                      
                      <Button 
                        variant='success' 
                        onClick={() => openSectionModal()}
                        >
                        <KTIcon iconName='plus' className='fs-2' />
                        Sección
                      </Button>   


                      {/* { sheetData.type !== "firma"   ? 
                          <Button variant='success' onClick={() => openSectionModal()}>
                            <KTIcon iconName='plus' className='fs-2' />
                            Sección
                          </Button>
                        : formDataFirmas.idproceso ?
                          <Button variant='success' onClick={() => openSectionModal()}>
                            <KTIcon iconName='plus' className='fs-2' />
                            Sección
                          </Button>
                        :
                          <OverlayTrigger
                            placement='right'
                            overlay={
                              <Tooltip id='disabled-tooltip'>
                                Seleccione un proceso para habilitar la sección
                              </Tooltip>
                            }
                          >
                            <Button variant='success' onClick={() => openSectionModal()}>
                              <KTIcon iconName='plus' className='fs-2' />
                              Sección
                            </Button>

                          </OverlayTrigger>
                      } */}
                      
                    </div>
                  </div>
                </Col>
                {/* <Col sm></Col> */}
              </Row>

              <Row className='mb-6'>
                <Col sm>
                  <DraggableSectionList permisos={permissions} />
                </Col>
                {/* <Col sm></Col> */}
              </Row>

              <Row>
                <div className='d-flex justify-content-end'>
                  <Button
                    variant='light'
                    className='mx-3'
                    type='reset'
                    onClick={() => {
                      goBack()
                    }}
                  >
                    Cancelar
                  </Button>
                  <Button variant='primary' type='submit'>
                    {!loading && 'Guardar'}
                    {loading && (
                      <span className='indicator-progress' style={{display: 'block'}}>
                        Guardando...{' '}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </Button>
                </div>
              </Row>
            </Container>
          </Form>
        )}
      </KTCard>

      <SectionEditModal />
      <FieldEditModal />
      <DocumentEditModal />
      <AssignmentEditModal />
      <AssignmentRequeridoModal />
      <AssignmentEntityModal />
      <PreviewModal />
    </SheetEditContext.Provider>
  )
}

export {SheetEdit}
